import React from 'react';

type StepCardRecord = {
  title: string;
  description: string;
};

type StepCardsProps = { records: StepCardRecord[] };

const StepCards: React.FC<StepCardsProps> = React.memo((props) => {
  const { records } = props;
  return (
    <div className="flex">
      <div className="flex flex-col md:flex-row mx-auto gap-4">
        {records.map((record, index) => {
          const shouldShowDivider = index < records.length - 1;
          const superscript = index < 9 ? `0${index + 1}` : index + 1;
          return (
            <React.Fragment key={index}>
              <div className="p-2 md:p-6">
                <span className="font-bold text-xl text-blueElectric">{superscript}</span>
                <h4 className="font-bold leading-none py-2">{record.title}</h4>
                <p>{record.description}</p>
              </div>
              {/* Desktop Divider */}
              {shouldShowDivider && <div className="my-8 w-[2px] h-[200px] bg-lightPurple/50 hidden md:block"></div>}
              {/* Mobile Divider */}
              {shouldShowDivider && <div className="my-2 h-[2px] w-full bg-lightPurple/50 block md:hidden"></div>}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
});
StepCards.displayName = 'StepCards';
export default StepCards;
